function customDebounce(func, within = 300, timerId = null) {
	window.callOnceTimers = window.callOnceTimers || {};
	if (timerId == null) timerId = func;
	var timer = window.callOnceTimers[timerId];
	clearTimeout(timer);
	timer = setTimeout(() => func(), within);
	window.callOnceTimers[timerId] = timer;
}

function cardFlipCheck() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.utils.toArray('.card-item.flip').forEach(function (card) {
    
		gsap.set(card, {
			transformStyle: 'preserve-3d',
			transformPerspective: 1000,
		});
		const q = gsap.utils.selector(card);
		const front = q('.card-blurb');
		const back = q('.card-details');

		gsap.set(back, { rotationY: -180 });

		const tl = gsap
			.timeline({ paused: true })
			.to(front, { duration: 0.7, rotationY: 180 })
			.to(back, { duration: 0.7, rotationY: 0 }, 0)
			.to(card, { z: 2 }, 0)
			.to(card, { z: 0 }, 0.5);
		
    if ($(window).width() >= 768) {
      card.addEventListener('mouseenter', function () {
        tl.play();
      });
      card.addEventListener('mouseleave', function () {
        tl.reverse();
      });
		} else {
      var flipAnimation = gsap.timeline({
				scrollTrigger: {
					trigger: card,
					start: 'top center',
					toggleActions: 'play none none reverse',
					// scrub:1,
					duration: 0.7,
				},
			});
      // flipAnimation.fromTo(card, {
      //   rotationY: 0,
      // }, {
      //   rotationY: 180,                                               
      // });
      flipAnimation.to(card, {
        rotationY: 180,
      });
    }
	});
}

$(document).ready(function () {
	$('a.wp-block-button__link[href^="#"]').click(function (e) {
		e.preventDefault();
		var $anchor = $(this).attr('href');
		console.log($anchor);
		$('html,body').animate({ scrollTop: $($anchor).offset().top }, 'slow');
	});

	var dynamic_sidebar_children = $('ul.dynamic-sidebar li[class*="children"]');

	$('ul.dynamic-sidebar li[class*="current"]').addClass('active');

	// plays with sidebar subnav states
	dynamic_sidebar_children.click(function () {
		dynamic_sidebar_children.not($(this)).removeClass('active');
		$(this).addClass('active');
		dynamic_sidebar_children
			.not($(this))
			.find('.children, .sub-menu')
			.stop()
			.slideUp();
		$(this).find('.children, .sub-menu').stop().slideDown();
	});

	// accordion functionality
	// TODO: Remove this and convert to HTML using the details & summary elements
	$('.accordion .accordion-item.active .copy').stop().slideDown();
	$('.accordion .accordion-item').click(function () {
		$('.accordion .accordion-item').not($(this)).removeClass('active');
		$('.accordion .accordion-item').not($(this)).find('.copy').slideUp();
		$(this).find('.copy').stop().slideToggle();
		$(this).toggleClass('active');
	});

	// fun scroll stuff for hero point
	if ($('.wp-block-cover.point-container').length > 0) {
		gsap.registerPlugin(ScrollTrigger);

		$('.wp-block-cover.point-container').each(function () {
			gsap.to($(this).find('.point .left'), {
				x: -50,
				rotation: -15,
				transformOrigin: '100% 100%',
				scrollTrigger: {
					trigger: $(this),
					start: 'top 10%',
					end: 'bottom 0',
					scrub: true,
				},
			});

			gsap.to($(this).find('.point .right'), {
				x: 50,
				rotation: 15,
				transformOrigin: '0 100%',
				scrollTrigger: {
					trigger: $(this),
					start: 'top 10%',
					end: 'bottom 0',
					scrub: true,
				},
			});
		});
	}

	if ($('.card-item.flip').length > 0) {
		cardFlipCheck();
		// fun flippy stuff for cards
	}
});

$(window).resize(function () {
	customDebounce(cardFlipCheck);
});
